import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import store from '@/vue/store';
import moment from 'moment';
import _ from 'lodash';
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
  store: store,
  mounted: function mounted() {
    this.getNewList();
  },
  computed: _objectSpread({}, mapGetters('app', ['h']), {}, mapGetters('news-store', ['newsList']), {
    lists: function lists() {
      return _.take(this.newsList.entries, 3); // 最新 3 件のエントリを取得
    }
  }),
  methods: _objectSpread({}, mapActions('news-store', ['getNewList']), {
    dateFormat: function dateFormat(e) {
      var date = moment(e);
      return date.format("YYYY.MM.DD");
    }
  })
}; // import store from '@/vue/store'
// import moment from 'moment'
// import { mapGetters, mapActions, mapMutations } from 'vuex'
// export default {
//   async created() {
//     await this.getNewsList()
//   },
//   methods: {
//     ...mapActions('news-store', [
//       'getNewsList'
//     ]),
//   },
// }